import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { DocumentLang } from '@/app/DocumentLang';
import { SUPPORT_EMAIL } from '@/shared/site';
import { localizePath } from '@/travo/i18n/locale';
import { msPath } from '@/membersheep/i18n';

const TRAVO_HOME = localizePath('en', '/');
const MEMBERSHEEP_HOME = msPath('en', '/');

interface LabsShellProps {
  children: ReactNode;
}

/** Header and footer of the Travo Labs root page (English only) and the site-wide 404. */
const LabsShell = ({ children }: LabsShellProps) => (
  <div className="min-h-screen bg-sys-bg font-apple text-sys-label antialiased">
    <DocumentLang lang="en" />
    <header className="mx-auto flex h-[72px] max-w-[1120px] items-center gap-7 px-4 md:px-6">
      <Link to="/" className="inline-flex items-baseline gap-[0.28em] font-display text-xl font-extrabold tracking-[-0.02em]">
        Travo <span className="font-medium text-sys-secondary">Labs</span>
      </Link>
      <nav aria-label="Primary" className="ml-auto hidden gap-[22px] text-[15px] text-sys-secondary sm:flex">
        <a href="/#apps" className="hover:text-current">
          Apps
        </a>
        <a href="/#contact" className="hover:text-current">
          Contact
        </a>
      </nav>
    </header>

    {children}

    <footer className="mt-24 border-t border-sys-separator pt-7 pb-12 text-[13px] text-sys-secondary">
      <div className="mx-auto flex max-w-[1120px] flex-wrap gap-x-6 gap-y-2 px-4 md:px-6">
        <Link to="/" className="mr-auto hover:text-sys-label">
          © {__BUILD_YEAR__} Travo Labs
        </Link>
        <Link to={TRAVO_HOME} className="hover:text-sys-label">
          Travo
        </Link>
        <Link to={MEMBERSHEEP_HOME} className="hover:text-sys-label">
          MemberSheep
        </Link>
        <a href={`mailto:${SUPPORT_EMAIL}`} className="hover:text-sys-label">
          {SUPPORT_EMAIL}
        </a>
      </div>
    </footer>
  </div>
);

export default LabsShell;
